import KendoTreeListMixin from './KendoTreeListMixin'

export default {
    name: 'kendo-treelist',
    mixins: [ KendoTreeListMixin ]
}


// WEBPACK FOOTER //
// ./packages/kendo-treelist-vue-wrapper/src/KendoTreeList/index.js